const API_BASE = 'https://htb4wmezrg.execute-api.us-west-2.amazonaws.com/prod/v2/msp';

export const createCompany = async (mspID, companyName, domain = '', rootUserEmail) => {
  const body = { mspID, companyName, rootUserEmail };
  if (domain) body.domain = domain;
  
  const response = await fetch(`${API_BASE}/companies/create`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  });
  if (!response.ok) throw new Error('Failed to create company');
  return response.json();
};

export const getMSPCompanies = async (mspID) => {
  const response = await fetch(`${API_BASE}/companies?mspID=${mspID}`);
  if (!response.ok) throw new Error('Failed to get companies');
  return response.json();
};

export const updateCompany = async (mspID, companyID, companyName, domain = '', rootUserEmail) => {
  const body = { mspID, companyID, companyName, rootUserEmail };
  if (domain) body.domain = domain;
  
  const response = await fetch(`${API_BASE}/companies/update`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  });
  if (!response.ok) throw new Error('Failed to update company');
  return response.json();
};

export const updateCompanyAccounts = async (mspID, companyID, accounts) => {
  const response = await fetch(`${API_BASE}/companies/accounts`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ mspID, companyID, accounts })
  });
  if (!response.ok) throw new Error('Failed to update company accounts');
  return response.json();
};

export const getCompanyDashboard = async (companyID) => {
  const response = await fetch(`https://htb4wmezrg.execute-api.us-west-2.amazonaws.com/prod/v2/finops/dashboard?companyID=${companyID}`);
  if (!response.ok) throw new Error('Failed to get company dashboard');
  return response.json();
};